/**
 * @file Photographer attribution banner.
 */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import classNames from 'classnames';

const propTypes = {
  account: PropTypes.shape({
    name: PropTypes.string,
    organization_name: PropTypes.string,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
};

const PhotographerAttributionBanner = ({ account }) => {
  const name = get(account, 'organization_name') || get(account, 'name');
  const logoUrl = get(account, 'logo_image.url');
  const titleClasses = classNames({
    'photographer-banner-title': true,
    'text-center': !logoUrl,
  });

  return (
    <div className="photographer-banner">
      <p className={titleClasses}>
        <span className="photographer-banner-title-label">
          Photos brought to you by
        </span>
        <span className="photographer-banner-title-name">{name}</span>
      </p>

      {logoUrl && (
        <div className="photographer-banner-logo">
          <img src={logoUrl} alt="" />
        </div>
      )}
    </div>
  );
};

PhotographerAttributionBanner.propTypes = propTypes;

export default PhotographerAttributionBanner;
